export default __webpack_public_path__ + "static/media/infographie.ddea81d3.png";